export const RETRY_PARENT_UPDATES = 'reduxBlend_RETRY_PARENT_UPDATES';
export const ADD_FAILED_ACTION = 'reduxBlend_ADD_FAILED_ACTION';

export const retryParent = (parent) => ({
  type: RETRY_PARENT_UPDATES,
  payload: parent,
});

export const addFailedAction = (parent, id, action) => ({
  type: ADD_FAILED_ACTION,
  payload: {
    parent,
    id,
    action,
  },
});
